<template>
  <div class="experience">
    <div class="cjh-title" v-if="!isDis">主要经历</div>
    <div class="cjh-cnt">
      <el-form
        ref="formRef"
        :model="ruleForm"
        :rules="rules"
        label-width="140px"
        label-position="left"
        :disabled="isDis"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="主要学习经历" prop="main_learning_experiences">
              <div
                class="zl-item"
                v-for="(item, index) in ruleForm.main_learning_experiences"
                :key="index"
              >
                <i
                  v-if="!isDis"
                  class="el-icon-delete icon-btn"
                  slot="reference"
                  @click="handleDel('main_learning_experiences', index)"
                ></i>

                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="起始年月"
                      :prop="
                        'main_learning_experiences.' + index + '.startDate'
                      "
                      :rules="btRules"
                    >
                      <el-date-picker
                        format="yyyy-MM"
                        value-format="yyyy-MM"
                        v-model="item.startDate"
                        type="month"
                        placeholder="请选择"
                        style="width: 100%"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="截止年月"
                      :prop="'main_learning_experiences.' + index + '.endDate'"
                      :rules="btRules"
                    >
                      <div class="endDate-warp">
                        <jzDate
                          :endTime.sync="item.endDateDate"
                          :formTimeYz.sync="item.endDate"
                          :nowFlag.sync="item.endDateNow"
                          :isDis="isDis"
                        ></jzDate>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="学校名称"
                      :prop="
                        'main_learning_experiences.' + index + '.schoolName'
                      "
                      :rules="btRules"
                    >
                      <el-input
                        v-model="item.schoolName"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="所在学院">
                      <el-input
                        v-model="item.college"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="所学专业"
                      :prop="'main_learning_experiences.' + index + '.major'"
                      :rules="btRules"
                    >
                      <el-input
                        v-model="item.major"
                        placeholder="请输入"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="学位"
                      :prop="'main_learning_experiences.' + index + '.degree'"
                      :rules="btRules"
                    >
                      <el-select
                        v-model="item.degree"
                        placeholder="请选择"
                        style="width: 100%"
                        clearable
                        filterable
                      >
                        <el-option
                          :label="item"
                          :value="item"
                          v-for="(item, index) in zgxwList"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                      label="导师"
                      :prop="'main_learning_experiences.' + index + '.mentor'"
                    >
                      <el-table
                        :data="item.mentor"
                        border
                        style="margin-bottom: 10px"
                        :header-cell-style="{
                          background: '#f8f8f9 !important',
                        }"
                      >
                        <el-table-column
                          label="序号"
                          width="55"
                          align="center"
                          type="index"
                        />
                        <el-table-column prop="name" label="姓名">
                          <template #default="scope">
                            <el-input
                              v-model="scope.row.name"
                              placeholder="请输入"
                            />
                          </template>
                        </el-table-column>
                        <el-table-column prop="unit" label="工作单位">
                          <template #default="scope">
                            <el-input
                              v-model="scope.row.unit"
                              placeholder="请输入"
                            />
                          </template>
                        </el-table-column>
                        <el-table-column prop="phone" label="手机">
                          <template #default="scope">
                            <el-input
                              v-model="scope.row.phone"
                              placeholder="请输入"
                            />
                          </template>
                        </el-table-column>
                        <el-table-column label="操作" width="90" v-if="!isDis">
                          <template #default="scope">
                            <el-button
                              link
                              type="primary"
                              icon="Delete"
                              @click="handleDelMentor(index, scope.$index)"
                              >删除</el-button
                            >
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-button
                        type="primary"
                        size="medium"
                        v-if="!isDis"
                        @click="item.mentor.push({})"
                        >添加新数据</el-button
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="附件"
                      :prop="'main_learning_experiences.' + index + '.fj'"
                    >
                      <uploadCom :list.sync="item.fj" :isDis="isDis"></uploadCom>
                      <!-- <el-upload
                        v-model:file-list="item.fj"
                        class="upload-demo"
                        action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
                        multiple
                        :limit="3"
                      >
                        <el-button size="medium">选择文件</el-button>
                        <template #tip>
                          <div class="el-upload__tip">
                            请上传学历学位证书（PDF格式，不超过5M）
                          </div>
                        </template>
                      </el-upload> -->
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-button

                type="primary"
                size="medium"
                v-if="ruleForm.main_learning_experiences.length < 6 && !isDis"
                @click="
                  ruleForm.main_learning_experiences.push({
                    mentor: [],
                    fj: [],
                  })
                "
                >添加新数据</el-button
              >
              <div class="tip" v-if="!isDis">请按时间顺序填写（从大学填起，6项以内）</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="主要工作经历" prop="main_work_experience">
              <div
                class="zl-item"
                v-for="(item, index) in ruleForm.main_work_experience"
                :key="index"
              >
                <i
                  class="el-icon-delete icon-btn"
                  @click="handleDel('main_work_experience', index)"
                  v-if="!isDis"
                ></i>
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                      label="起始年月"
                      :prop="'main_work_experience.' + index + '.startDate'"
                      :rules="btRules"
                    >
                      <el-date-picker
                        format="yyyy-MM"
                        value-format="yyyy-MM"
                        v-model="item.startDate"
                        type="month"
                        placeholder="请选择"
                        style="width: 100%"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item
                      label="截止年月"
                      :prop="'main_work_experience.' + index + '.endDate'"
                      :rules="btRules"
                    >
                      <jzDate
                        :endTime.sync="item.endDateDate"
                        :formTimeYz.sync="item.endDate"
                        :nowFlag.sync="item.endDateNow"
                        :isDis="isDis"
                      ></jzDate>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item
                      label="工作单位"
                      :prop="'main_work_experience.' + index + '.unit'"
                      :rules="btRules"
                    >
                      <el-input
                        v-model="item.unit"
                        placeholder="请填写至部门"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item
                      label="职务"
                      :prop="'main_work_experience.' + index + '.position'"
                      :rules="btRules"
                    >
                      <el-input
                        v-model="item.position"
                        placeholder="如没有，请填写无"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-button
                type="primary"
                size="medium"
                v-if="ruleForm.main_work_experience.length < 6 && !isDis"
                @click="ruleForm.main_work_experience.push({})"
                >添加新数据</el-button
              >
              <div class="tip" v-if="!isDis">请按时间倒序填写（6项以内）</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="btn-warp" v-if="!isDis">
      <el-button type="primary" plain class="btn" @click="handleSaveZc"
        >暂存数据</el-button
      >
      <el-button type="primary" class="btn" @click="handleSave">保存</el-button>
    </div>
  </div>
</template>
<script>
import { nextTick } from 'vue'
import { update_data, getUserInfo } from '../../axios/api'
import jzDate from './components/jzDate.vue'
import uploadCom from './components/uploadCom.vue'

export default {
  props: {
    isDis: {
      type: Boolean,
      default: false
    }
  },
  components: {
    jzDate,
    uploadCom
  },
  data () {
    return {
      zgxwList: ['博士', '硕士', '学士', '无'],
      btRules: [
        { required: true, message: '必填', trigger: ['blur', 'change'] }
      ],
      ruleForm: {
        main_learning_experiences: [],
        main_work_experience: []
      },
      rules: {
        main_learning_experiences: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        main_work_experience: [
          { required: true, message: '必填', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    if (this.isDis) {
      this.ruleForm = sessionStorage.getItem('cjhuser')
        ? JSON.parse(sessionStorage.getItem('cjhuser'))
        : {}
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate()
      })
    } else {
      this.ruleForm = sessionStorage.getItem('uinfo')
        ? JSON.parse(sessionStorage.getItem('uinfo'))
        : {}
    }

    this.ruleForm.main_learning_experiences = this.ruleForm
      .main_learning_experiences
      ? JSON.parse(this.ruleForm.main_learning_experiences)
      : []
    this.ruleForm.main_work_experience = this.ruleForm.main_work_experience
      ? JSON.parse(this.ruleForm.main_work_experience)
      : []
  },
  methods: {
    saveFun () {
      const params = {
        ...this.ruleForm,
        token: sessionStorage.getItem('Token3')
      }
      params.main_learning_experiences = params.main_learning_experiences
        ?.length
        ? JSON.stringify(params.main_learning_experiences)
        : ''
      params.main_work_experience = params.main_work_experience?.length
        ? JSON.stringify(params.main_work_experience)
        : ''
      update_data({ ...params }).then((ress) => {
        if (ress.data.code === 200) {
          getUserInfo({ token: sessionStorage.getItem('Token3') }).then(
            (res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                sessionStorage.setItem('uinfo', JSON.stringify(res.data.data))
              }
            }
          )
        }
      })
    },
    handleSaveZc () {
      this.saveFun()
    },
    handleSave () {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.saveFun()
        } else {
          console.log('error submit!!')
          this.$message({
            message: '请填写完必填项',
            type: 'error'
          })
          return false
        }
      })
    },
    // 删除导师
    handleDelMentor (index, chIndex) {
      this.ruleForm.main_learning_experiences[index].mentor.splice(chIndex, 1)
    },
    // 确定删除
    handleDel (attr, index) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.ruleForm[attr].splice(index, 1)
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped>
.experience {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  .el-form-item .el-form-item {
    margin-bottom: 20px;
  }
  .cjh-cnt {
    flex: 1;
    overflow-y: auto;
    padding: 20px 25px;
  }
  .cjh-title {
    padding: 20px 25px;
    border-bottom: 1px solid rgba(220, 220, 220, 0.5);
    font-weight: 600;
    font-size: 20px;
  }
  .btn-warp {
    background: #fff;
    padding: 30px 50px;
    left: 0;
    bottom: 0;
    .btn {
      height: 42px;
    }
  }
  .tip {
    color: #999;
  }
  .zl-item {
    border: 1px solid #eee;
    padding: 20px;
    position: relative;
    background-color: #f9f9f9;
    margin-bottom: 10px;
    .icon-btn {
      cursor: pointer;
      font-size: 20px;
      position: absolute;
      top: 2px;
      right: 2px;
    }
  }
}
</style>
